import Spinner from "../../../../components/Spinner.jsx";
import {useTranslation} from "react-i18next";
import {useContext, useEffect, useState} from "react";
import {GlobalContext} from "../../../../utils/context/GlobalContextProvider.jsx";
import useDownloadState from "../../../../api/utilities/useDownloadState.js";
import LoadingComponent from "../../../../components/LoadingComponent.jsx";
import {ProjectIntegrationsApi} from "../../../../api/authority/generated/index";
import pinterestLogo from "../../../../images/remixicons/Logos/pinterest-fill.svg";
import OAuthAdAccountsFormLayout from "../OAuthAdAccountsFormLayout.jsx";
import {IntegrationConnectButton} from "../IntegrationDetailUi.jsx";

export default function PinterestIntegrationForm({project, projectIntegration, refreshOAuthResources}) {

    let {t} = useTranslation();

    let adAccountDefaultValues = [];
    let adAccountOptions = [];

    for (let adAccount of projectIntegration?.pinterestIntegrationAdAccounts ?? []) {
        adAccountOptions.push({
            value: adAccount.accountId,
            label: '[' + adAccount.accountId + '] ' + adAccount.name
        });

        if (adAccount.enabled) {
            adAccountDefaultValues.push({
                value: adAccount.accountId,
                label: '[' + adAccount.accountId + '] ' + adAccount.name
            });
        }
    }

    let [selectedAdAccounts, setSelectedAdAccounts] = useState(adAccountDefaultValues);

    const {context, getAuthorityConfiguration, resetCurrentUserProjects} = useContext(GlobalContext);

    let redirectToLogin = () => {
        let oAuthUrl = new URL(import.meta.env.VITE_AUTHORITY_URL);
        oAuthUrl.pathname = '/api/v1/project/integrations/pinterest';

        let query = new URLSearchParams({
            authorization: context.currentIdentity?.token,
            projectId: project.id,
        });

        if (projectIntegration?.id) {
            query.set('integrationId', projectIntegration.id);
        }

        oAuthUrl.search = query.toString();

        window.location.href = oAuthUrl.toString();
    };

    useEffect(() => {
        if (!projectIntegration) {
            setTimeout(
                () => redirectToLogin(),
                100,
            );
        }
    }, []);

    let [state, setDownloading] = useDownloadState();

    let saveAdAccounts = () => {
        let adAccountIds = [];

        for (let adAccountOption of selectedAdAccounts) {
            adAccountIds.push(adAccountOption.value);
        }

        setDownloading(true);
        new ProjectIntegrationsApi(getAuthorityConfiguration())
            .choosePinterestAdAccounts({
                projectId: project.id,
                integrationId: projectIntegration.id,
                requestBody: adAccountIds
            })
            .then(() => {
                resetCurrentUserProjects();
            })
            .finally(() => setDownloading(false));
    };

    const refreshAdAccounts = () => {
        setDownloading(true);
        Promise.resolve(refreshOAuthResources())
            .finally(() => setDownloading(false));
    };

    if (!projectIntegration) {
        return (
            <div>
                <Spinner size={'spinner-large'} className={'mx-auto'}/>
                <p className={'text-center mt-4'}>{t('redirecting')}...</p>
            </div>
        );
    }

    let reconnectRequired = !projectIntegration.authorizationSuccessful || (projectIntegration.errors ?? []).length > 0;

    return (
        <LoadingComponent loading={state.downloading}>
            <OAuthAdAccountsFormLayout
                providerName={'Pinterest Ads'}
                reconnectRequired={reconnectRequired}
                connectButton={<IntegrationConnectButton logo={pinterestLogo} logoAlt={'Pinterest'} label={reconnectRequired ? 'Připojit' : 'Obnovit připojení'} onClick={redirectToLogin}/>}
                accountSelectName={'pinterest-ad-accounts'}
                selectedAccounts={selectedAdAccounts}
                accountOptions={adAccountOptions}
                onAccountsChange={setSelectedAdAccounts}
                onRefresh={refreshAdAccounts}
                onSave={saveAdAccounts}
            />
        </LoadingComponent>
    );
}
